import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUndoUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconArrowUndoUp"><Path d="M6.24977 5L3.31043 7.93934C2.72465 8.52513 2.72465 9.47487 3.31043 10.0607L6.24977 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M4 9H16.625C19.1793 9 21.25 11.0707 21.25 13.625C21.25 16.1793 19.1793 18.25 16.625 18.25H11.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowUndoUp;
